import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { CampaignPerformanceTotals } from 'apis/merchant-gateway/insights/campaigns-performance/types';
import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography as T } from 'common/typography';

import { CampaignAnalyticsDateRageFilter } from './CampaignAnalyticsDateRageFilter';
import { CampaignAnalyticsMetrics } from './CampaignAnalyticsMetrics';
import { useCampaignModuleContext } from '../../context';
import { DateRange } from '../../types';

const Root = styled.div`
  border: 1px solid ${cbSemanticCssVars.borderPrimary};
  border-radius: 8px;
`;

const HeaderRow = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

const MetricsRow = styled.div`
  padding: 16px;
`;

export const CampaignListMetrics = ({
  campaignPerformance,
  isLoading,
  dateRange,
  setDateRange,
}: {
  campaignPerformance?: CampaignPerformanceTotals;
  isLoading?: boolean;
  dateRange: DateRange;
  setDateRange: (dateRange: DateRange) => void;
}) => {
  const { formatMessage } = useIntl();
  const { currency, entityType } = useCampaignModuleContext();

  const {
    totalOrders,
    avgBasketValue,
    avgBasketSize,
    totalSpend,
    returningCustomers,
    newCustomers,
    totalSales,
    avgCostPerOrder,
  } = campaignPerformance ?? {};

  return (
    <Root>
      <HeaderRow>
        <T.Heading6>{formatMessage({ id: 'campaigns.analytics.campaign-performance' })}</T.Heading6>
        <CampaignAnalyticsDateRageFilter onUpdate={setDateRange} dateRange={dateRange} />
      </HeaderRow>
      <MetricsRow>
        <CampaignAnalyticsMetrics
          currency={currency}
          colored
          isLoading={isLoading}
          metrics={{
            totalSales: totalSales ?? 0,
            totalSpend: totalSpend ?? 0,
            totalOrders: totalOrders ?? 0,
            averageBasketValue: avgBasketValue ?? 0,
            averageBasketItemsCount: avgBasketSize ?? 0,
            averageCostPerOrder: avgCostPerOrder ?? 0,
            ...(entityType === 'venue' || newCustomers != null ? { newCustomers: newCustomers ?? 0 } : {}),
            ...(entityType === 'venue' || returningCustomers != null
              ? { returningCustomers: returningCustomers ?? 0 }
              : {}),
          }}
          isSingleCampaign
        />
      </MetricsRow>
    </Root>
  );
};
